import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { RootState } from "store/rootReducer";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef, ValueFormatterParams } from "@material-ui/data-grid";
import {
  fetchAllBanners,
  deleteBanner,
  selectAllBanners,
  selectLoading,
} from "features/admin/Banners/bannersAdminSlice";
import { setResponseMessage } from "features/admin/adminSlice";
import { colors } from "@material-ui/core";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdCheckCircle } from "react-icons/md";
import { CenteredTableRow } from "./columns/UpdatableCountField";
interface AllBannersTableProps {}
const columns: ColDef[] = [
  { sortable: false, field: "title", headerName: "Име", width: 400 },
  {
    field: "is_active",
    headerName: "Активен",
    width: 100,
    renderCell: (params: ValueFormatterParams) => (
      <CenteredTableRow>
        {params.value ? (
          <MdCheckCircle
            color={colors.green[500]}
            style={{ width: 32, height: 32 }}
          />
        ) : (
          <AiFillCloseCircle
            color={colors.red[500]}
            style={{ width: 32, height: 32 }}
          />
        )}
      </CenteredTableRow>
    ),
    align: "center",
  },
];

const BannersTable: React.FC<AllBannersTableProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const banners = useSelector(selectAllBanners);
  const isLoading = useSelector(selectLoading);
  useEffect(() => {
    dispatch(fetchAllBanners());
  }, [dispatch]);

  const add = () => {
    navigate("/banners/add");
  };
  const refresh = () => {
    dispatch(fetchAllBanners());
  };
  const remove = (ids: string[]) => {
    ids.forEach((id: string) => {
      const _refId = banners.find(
        (item: { id: number }) => item.id === parseInt(id)
      )?.refId;
      _refId &&
        batch(() => {
          dispatch(setResponseMessage({ message: "", hasError: false }));
          dispatch(deleteBanner(_refId));
        });
    });
    dispatch(fetchAllBanners());
  };

  const edit = (id: string) => {
    const _refId = banners.find(
      (item: { id: number }) => item.id === parseInt(id)
    )?.refId;
    _refId && navigate(`/banners/edit/${_refId}`);
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      remove={remove}
      edit={edit}
      data={banners}
      columns={columns}
      isLoading={isLoading}
      searchProperty="title"
    />
  );
};

export default BannersTable;
